import type { FC } from 'react';
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import Lozenge from '@atlaskit/lozenge';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StatusLozengeWrapper = styled.span({
	marginLeft: token('space.050', '4px'),
	fontStyle: 'normal',
	flex: 1,
});

export const i18n = defineMessages({
	draftLozengeText: {
		id: 'page-tree.status.draft',
		defaultMessage: 'DRAFT',
		description: 'User has started a page but has not published it yet',
	},
});

export const DraftLozenge: FC = () => (
	<StatusLozengeWrapper>
		<Lozenge appearance="default">
			<FormattedMessage {...i18n.draftLozengeText}>
				{(message) => <span data-testid="draft-status-lozenge">{message}</span>}
			</FormattedMessage>
		</Lozenge>
	</StatusLozengeWrapper>
);
